import { Component,Input,ViewChild } from '@angular/core';
import {GoogleMap,MapCircle,MapAdvancedMarker, MapPolyline} from '@angular/google-maps';


interface placeLocation {
  position:  google.maps.LatLngLiteral;
  name:      string;
  address:   string;
}

declare function slickGoTo(index:number): void;

@Component({
  selector: 'train-google-map',
  standalone: true,
  //引用的功能
  imports: [GoogleMap,MapCircle,MapAdvancedMarker,MapPolyline],
  templateUrl: './google-map.component.html',
})

export class GoogleMapComponent {

  /*--------------------組件與服務初始化-------------------*/

  // [GoogleMap] 子組件
  @ViewChild(GoogleMap) readonly map!: GoogleMap;

  @Input() startLocation: placeLocation;
  @Input() endLocation: placeLocation;
  @Input() detail: any;
  @Input() attractionArray: any;
  @Input() state: number;



  /*--------------------地圖基礎設定---------------------*/

  // 地圖中心座標
  center: google.maps.LatLngLiteral = {lat: 24.18780271497496 , lng: 120.6642562077388};

  // 預設地圖大小
  zoom = 17;

  // 其他不會變動的設定值
  options: google.maps.MapOptions = {

    //地圖大小區間
    maxZoom: 20,
    minZoom: 12,

    //(必填)地圖標記功能使用
    mapId: "MAAS_MAP_TRAIN",

    // 除了地圖大小控制項，其他UI介面不顯示
    streetViewControl: false,
    fullscreenControl:false,
    mapTypeControl:false,

    // 地圖大小控制項預設位置: 4.0(左側中間)
    zoomControlOptions: {
      position: 4.0
    }
  };


 /*--------------------angular 預設 funtion()---------------------*/

  /**
  * ngOnInit(初始化後呼叫)
  */

  ngOnInit(){

  }

  getLocal() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        },
        (error) => {
          console.log('Geolocation error:', error);
        }
      );
    }
  }

  showDetail(index:number){
    slickGoTo(index);
  }

  changeCenter(lat:number, lng:number) {
    this.zoom = 15;
    this.center = {
      lat:lat,
      lng:lng
    };
  }

}
